<template>
    <StaticSpinner v-if="!loaded && !eventsError && isEnabledEvents" />

    <template v-if="hasEFootballMatches">
        <EFootballBlock v-bind:displayEventsCount="displayEventsCount" v-bind:isLive="isShowLive" />

        <div class="eFootballOddsWrapper" v-bind:class="{ isJackpotEnabled }">
            <OddsDisplay
                v-if="isShowLive"
                v-resize="triggerRedraw"
                v-bind:isLive="true"
                v-bind:isSticky="true"
                v-bind:redrawSignal="redrawSignal"
            />
            <OddsDisplay
                v-if="isShowNonLive"
                v-bind:isLive="false"
                v-bind:isSticky="true"
                v-bind:redrawSignal="redrawSignal"
            />
        </div>
    </template>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed, watch } from 'vue';
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import OddsDisplay from '@/components/oddsDisplay/OddsDisplay.vue';
    import { OddsDisplayBlockContext } from '@/components/oddsDisplay/OddsDisplayBlockContext';
    import { MarketPage, SiteStyle } from '@/interface/enum';
    import { useLayoutStore } from '@/store/layoutStore';
    import { useToggleStore } from '@/store/toggleStore';
    import EFootballBlock from '@/views/tournamentCenter/EFootballBlock.vue';

    const { eFootballZoneLeagueIds, isJackpotEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const { marketPage, loaded, displayEvents, eventsError, isEnabledEvents } = OddsDisplayBlockContext.provide({
        leagueIds: eFootballZoneLeagueIds,
    });

    const isShowNonLive = computed(() => marketPage !== MarketPage.Live);
    const isShowLive = computed(() => {
        if (marketPage === MarketPage.Live) return true;
        if (marketPage === MarketPage.Today) {
            return displayEvents.value.some(x => x.isLive);
        }
        return false;
    });
    const displayEventsCount = computed(() => displayEvents.value.length);

    const hasEFootballMatches = computed(() => displayEventsCount.value > 0);

    const { redrawSignal } = storeToRefs(useLayoutStore());
    const { triggerRedraw } = useLayoutStore();

    watch(isShowLive, triggerRedraw);
</script>

<style lang="scss" scoped>
    @import "@/views/tournamentCenter/EFootballOddsDisplayBlock";
</style>
